import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import './ReassignmentModal.css';

const ReassignmentModal = ({
  show,
  onClose,
  title = 'Reassign Patients',
  description,
  patients = [],
  alternatives = [],
  reassignments = {},
  onReassignmentChange,
  onSave,
  isSaving = false,
  saveLabel = 'Save',
  optionPlaceholder = 'Select...',
  showOptionPlaceholder = true,
  showMeta = false,
  showIndex = false,
  hideCurrentColumn = false,
  currentLabel = 'Current',
  reassignToLabel = 'Reassign to',
  getPatientName,
  getCurrentAssignee,
  getAlternativeId,
  getAlternativeName
}) => {
  const patientName = getPatientName || ((p) => `${p?.first_name || ''} ${p?.last_name || ''}`.trim() || 'N/A');
  const currentAssignee = getCurrentAssignee || (() => 'N/A');
  const alternativeId = getAlternativeId || ((x) => x?.id);
  const alternativeName = getAlternativeName || ((x) => `${x?.first_name || ''} ${x?.last_name || ''}`.trim() || 'N/A');
  const getAssignment = (patientId) => {
    const raw = reassignments?.[patientId] ?? reassignments?.[String(patientId)] ?? '';
    return typeof raw === 'string' ? raw.trim() : raw;
  };
  const hasUnassigned = patients.some((p) => !getAssignment(p.id));

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      dialogClassName="reassign-modal-dialog"
      contentClassName="reassign-modal-content"
      backdrop="static"
    >
      <Modal.Header className="reassign-modal-header" closeButton={false}>
        <Modal.Title as="h5" className="reassign-modal-title">{title}</Modal.Title>
        <button type="button" className="reassign-modal-close" onClick={onClose} aria-label="Close">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>

      <Modal.Body className="reassign-modal-body">
        {description ? <p className="reassign-modal-description">{description}</p> : null}

        {showMeta ? (
          <div className="reassign-modal-meta">
            <span>{patients.length} patient(s)</span>
            <span>{alternatives.length} option(s)</span>
          </div>
        ) : null}

        <div className="reassign-modal-table-wrap">
          <table className="reassign-modal-table">
            <thead>
              <tr>
                {showIndex ? <th>#</th> : null}
                <th>Patient</th>
                {!hideCurrentColumn ? <th>{currentLabel}</th> : null}
                <th>{reassignToLabel}</th>
              </tr>
            </thead>
            <tbody>
              {patients.map((patient, idx) => (
                <tr key={patient.id}>
                  {showIndex ? <td className="reassign-modal-index">{idx + 1}</td> : null}
                  <td className="reassign-modal-patient">{patientName(patient)}</td>
                  {!hideCurrentColumn ? (
                    <td className="reassign-modal-current">{currentAssignee(patient)}</td>
                  ) : null}
                  <td>
                    <select
                      className="form-select form-select-sm reassign-modal-select"
                      value={getAssignment(patient.id) || ''}
                      onChange={(e) => onReassignmentChange(patient.id, e.target.value)}
                    >
                      {showOptionPlaceholder ? <option value="">{optionPlaceholder}</option> : null}
                      {alternatives.map((item) => (
                        <option key={alternativeId(item)} value={alternativeId(item)}>
                          {alternativeName(item)}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer className="reassign-modal-footer">
        <button type="button" className="reassign-modal-btn reassign-modal-btn--ghost" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="reassign-modal-btn reassign-modal-btn--primary"
          onClick={onSave}
          disabled={isSaving || hasUnassigned}
        >
          {isSaving ? <FontAwesomeIcon icon={faSpinner} spin className="me-2" /> : null}
          {saveLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReassignmentModal;
